import { createAction } from '@reduxjs/toolkit';

export const getbusinessId = createAction('BUSINESS_ID', ( data) => {
    return{
        payload: {
			data
        }
    }
}); 
export const getonboardingStatus = createAction('ONBOARDING_STATUS', ( data) => {
    return{
        payload: {
			data
        }
    }
}); 
export const getonboardingbusinessInfoRequest = createAction('GET_BUSINESS_INFO', (businessId) => {
    return{
        payload: {
			data : {
				businessId
			}
        }
    }
});

export const getonboardingbusinessInfoSuccess = createAction('GET_BUSINESS_SUCCESS', data => {
    return{
        payload: {
			data
        }
    }
});
export const getonboardingbusinessInfoFailure = createAction('GET_BUSINESS_FAILURE', error => {
    return{
        payload: {
			error
        }
    }
});